import { Component, OnInit, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { RequisitionService } from '../services/requisition.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-list-req-no-freelancer',
  templateUrl: './list-req-no-freelancer.component.html',
  styleUrls: ['./list-req-no-freelancer.component.css']
})
export class ListReqNoFreelancerComponent implements OnInit {

  listReq: any;
  loading: boolean;
  max: number;
  page: number;
  total: number;

  constructor(
    private dialog: MatDialog,
    private requisitionService: RequisitionService,
    private _router: Router
  ) {
    this.loading = false;
    this.max = 10;
  }

  ngOnInit() {
    this.refreshListing(1);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.refreshListing(1);
  }

  refreshListing(page) {
    this.loading = true;
    this.requisitionService.getReqNoFreelancer(page)
    .subscribe(
      res => {
        this.loading = false;
        this.page = page;
        this.total = res.pagination.total;
        this.listReq = res.requisitions;
      },
      () => {
        console.log('Error retrieving Requisitions');
        this.loading = false;
      }
    );
  }

  gotoRequisition(requisition) {
    this._router.navigate(['/viewrequisition', requisition.id]);
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/list-req-no-freelancer/list-req-no-freelancer.component.ts